import * as Constantes from '../../../shared/constants';

// Componentes 
import { Component, OnInit, ViewChild } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';

//Modelos e Interfaces
import { IAlmacen } from 'src/app/interfaces/almacenes';
import { ICliente } from 'src/app/interfaces/cliente';
import { IStock } from 'src/app/interfaces/stock';
import { IArticulo } from 'src/app/interfaces/articulo';

// Servicios
import { AlmacenesService } from 'src/app/services/datos/almacenes.service';
import { ClientesService } from 'src/app/services/datos/clientes.service';
import { StockService } from 'src/app/services/datos/stock.service';
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { ModalRegularizarService } from 'src/app/services/modal-regularizar.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { ArticulosService } from 'src/app/services/datos/articulos.service';
import { EanLabelsService } from 'src/app/services/ean-labels.service';

// Librerias
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import FuncLib from 'src/app/providers/funcionesLib';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-stock-list',
  templateUrl: './stock-list.component.html',
  styleUrls: ['./stock-list.component.scss'],
})
export class StockListComponent implements OnInit {
  // Usar constantes en el template
  Constantes = Constantes;

  public funcLib: FuncLib = new FuncLib();
  paramId: string = '';
  articuloAux: IArticulo = {};

  loading: boolean = false;
  textoDestacado: string = '';
  public strBuscarTodo: string = '';

  messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: 'Total',
    selectedMessage: 'seleccionado',
  };

  stockList: IStock[] = [];
  almacenesList: IAlmacen[] = [];
  clientesList: ICliente[] = [];

  rows: any[] = [];
  temp: any[] = [];

  columns = [];
  ColumnMode = ColumnMode;

  opcionesList: {
    id_cliente?: number;
    id_almacen?: number;
    id_articulo?: number;
    id_ubicacion?: number;
  } = {};

  almSeleccionado: string = this.usuarioSrv.userdata.alm_por_defecto || '0'; // Almacén por defecto
  cliSeleccionado: string = '';

  public summaryPosition: string =
    localStorage.getItem('summaryPosition') || 'bottom';
  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  @ViewChild(StockListComponent) table: StockListComponent | any;

  constructor(
    private activatedRoute: ActivatedRoute,
    public stockSrv: StockService,
    public almacenesSrv: AlmacenesService,
    public clientesSrv: ClientesService,
    public usuarioSrv: UsuarioService,
    public modalRegulSrv: ModalRegularizarService,
    private notificacionesSrv: NotificacionesService,
    public eanLabelsSrv: EanLabelsService,
    public articuloSrv: ArticulosService
  ) { }

  ngOnInit(): void {

    // Suscribirse a los parámetros de la url, si envían una id, cargar los datos del articulo
    this.activatedRoute.params.subscribe(({ id }) => {
      this.paramId = id;
      this.opcionesList.id_articulo = id;

      if (this.paramId) {
        this.articuloSrv.getArticulo(id).subscribe((resp) => {
          this.loading = false;
          this.articuloAux = resp.data;
          console.log('__articuloAux', this.articuloAux);
          this.cliSeleccionado = this.articuloAux.id_cliente?.toString() || '0';
        });
      }

    });

    this.getListaStock();

    this.almacenesSrv.getLista().subscribe((respuesta) => {
      this.loading = false;
      this.almacenesList = respuesta.data;
    });

    this.clientesSrv.getLista().subscribe((resp) => {
      this.loading = false;
      this.clientesList = resp.data.filter(
        (cliente: { archivado: boolean }) => !cliente.archivado
      );
    });
  }

  getListaStock() {
    this.opcionesList.id_almacen = parseInt(this.almSeleccionado);
    this.opcionesList.id_cliente = parseInt(this.cliSeleccionado);



    this.loading = true;

    this.stockSrv.getLista(this.opcionesList).subscribe((respuesta) => {
      this.loading = false;
      this.stockList = respuesta.data;

      console.log('getLista', this.stockList);

      this.rows = this.stockList;
      this.temp = [...this.stockList];
    });
  }

  // Búscar y filtrar

  filtro(val: string, campo: string) {
    // filter our data
    const temp = this.temp.filter(function (d) {
      if (d[campo]) return d[campo].toLowerCase().indexOf(val) !== -1 || !val;
      return !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.stockList;
  }

  buscar(event: any, campo: string) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    this.filtro(txt, campo);
  }

  buscarTodo(event: any) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    this.buscaGlobal(txt);
  }

  dblclickCampo(valor: any) {
    this.strBuscarTodo = String(valor);
    const txt = valor.toLowerCase() ?? '';
    this.buscaGlobal(txt);
  }

  buscaGlobal(txt: string) {
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    // Marcar el texto destacado
    this.textoDestacado = txt;

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.stockList;
  }

  limpiaBusca() {
    this.strBuscarTodo = '';
    this.buscaGlobal('');
    const buscaTodoInput = document.getElementById('buscaTodo');
    buscaTodoInput?.focus();
  }

  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr); // convertir el valor a número
  }

  onAlmacenSelect(id: string) {
    this.almSeleccionado = id;
    this.opcionesList.id_almacen = parseInt(id);
    this.getListaStock();
  }

  onClienteSelect(id: string) {
    this.cliSeleccionado = id;
    this.opcionesList.id_cliente = parseInt(id);
    this.getListaStock();
  }

  //  CRUD  //

  deleteReserva(row: IStock) {
    Swal.fire({
      title: '¿Borrar reserva?',
      icon: 'question',
      html: ` <p>EAN: <b>${row.articuloEan}</b> Sku: <b>${row.articuloSku}</b></p>
              <p>${row.articuloDescripcion}</p>
              <p><span class="text-danger">Asegúrate de que <b>NO</b> existan campañas en curso para este cliente</span></p>
              <p><small><i class="text-info fa-solid fa-circle-info"></i> Se deshará la reserva de ${row.cantidadReservada} unidades</small></p>
              `,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.stockSrv.deleteReserva(row.id!).subscribe((resp) => {
          this.loading = false;
          console.log('__deleteReserva() resp', resp);
          if (resp.error) {
            this.notificacionesSrv.aviso('error', resp.mensaje);
            return;
          }
          this.notificacionesSrv.aviso('success', resp.mensaje);
          this.getListaStock();
        });
      }
    });
  }

  // Borrar registro y crear transacciónnegativa
  deleteRow(row: IStock) {
    const cantidad = row.cantidad ?? 0;
    const cantidadReservada = row.cantidadReservada ?? 0;
    if (cantidadReservada > 0) {
      this.notificacionesSrv.aviso(
        'error',
        'No puedes eliminar registros de Stock con cantidades reservada'
      );
      return;
    }

    Swal.fire({
      title: '¿Borrar registro de stock?',
      icon: 'question',
      html: `
              <p>EAN: <b>${row.articuloEan}</b> Sku: <b>${row.articuloSku
        }</b></p>
              <p>${row.articuloDescripcion}</p>
              <p><small><i class="text-info fa-solid fa-circle-info"></i> Generará un registro de transacción con <b>${cantidad * -1
        }</b> unidades</small></p>
              <p><input type="text" id="motivo" class="form-control" placeholder="Motivo del borrado"></p>
              `,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
      preConfirm: () => {
        const motivo = (
          document.getElementById('motivo') as HTMLInputElement
        ).value.trim();
        if (motivo.length < 4) {
          Swal.showValidationMessage(
            'El motivo debe tener al menos 4 caracteres'
          );
        }
        if (!motivo) {
          Swal.showValidationMessage('Debes introducir el motivo del borrado');
        }
        return { motivo };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const motivo = result.value?.motivo || '';
        const datos = {
          id: row.id,
          descripcion: motivo,
          username: this.usuarioSrv.userdata.username,
        };
        this.stockSrv.delete(datos).subscribe((resp) => {
          if (resp.error) {
            this.notificacionesSrv.aviso('error', resp.mensaje);
          } else {
            this.notificacionesSrv.aviso('info', resp.mensaje);
            this.rows = this.rows.filter((objeto) => objeto.id !== row.id);
          }
        });
      }
    });
  }

  //  AUX // 

  // EXPORTAR A EXCEL
  exportToExcel(): void {

    const fileName = `Stock-${new Date().toISOString()}.xlsx`;

    // 1. Calcular conteo de ubicaciones
    const conteoUbicaciones: Record<string, number> = {};

    this.rows.forEach(row => {
      const key = row.ubicacion?.id ?? row.ubicacion?.codigo;

      if (key !== undefined && key !== null) {
        conteoUbicaciones[key] = (conteoUbicaciones[key] || 0) + 1;
      }
    });

    // 2. Mapear datos con columna nueva
    const dataToExport = this.rows.map(row => {
      const flattened: any = { ...row };

      // Limpiar campos no necesarios del stock
      delete flattened.ubiCodigo;
      delete flattened.ubiSwOcupado;

      let ubicacionKey: string | number | undefined;

      if (flattened.ubicacion) {

        ubicacionKey = flattened.ubicacion.id ?? flattened.ubicacion.codigo;

        Object.keys(flattened.ubicacion).forEach(key => {
          flattened[`ubicacion_${key}`] = flattened.ubicacion[key];
        });

        // Añadir columna calculada cajetín
        flattened['ubicacion_cajetin'] = flattened[`ubicacion_codigo`]?.endsWith('00') ? 0 : 1;

        //Número de registros con la misma ubicación
        flattened['cuenta_ubicaciones'] = ubicacionKey !== undefined ? conteoUbicaciones[ubicacionKey] : 0;

        // Limpiar campos no necesarios de la ubicación 
        delete flattened.ubicacion_created_at;
        delete flattened.ubicacion_updated_at;
      }

      // Limpiar campos no necesarios del articulo
      if (flattened.articulo) {
        delete flattened.articulo;
      }

      return flattened;
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();

    // Forzar valores numéricos en las columnas Xlsx
    Object.entries(worksheet).forEach(([cell, cellObj]: any) => {
      if (!cell.startsWith('!') && !isNaN(cellObj.v) && cellObj.v !== '') {
        cellObj.v = Number(cellObj.v);
        cellObj.t = 'n';
      }
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName);
  }

  abrirModalRegul(row: IStock) {
    this.modalRegulSrv.stock = row;
    this.modalRegulSrv.abrirModal();

    row.cantidad = this.modalRegulSrv.stock?.cantidad ?? 0;
  }

  public sumaCeldas(cells: any[]) {
    // Devuelve la suma de la columna, formateada y sin decimales
    const filteredCells = cells.filter((cell) => !!cell);
    const sum: number = filteredCells.reduce(
      (accumulator, currentValue) => accumulator + parseFloat(currentValue),
      0
    );
    // return sum.toLocaleString('es');
    return sum.toLocaleString('de-DE');
  }
}
